export default "__VITE_ASSET__41fb1de6__"